<div (click)="onClick()" class="flex flex-row p-2 gap-2 group hover:cursor-pointer hover:bg-ponder-linkhover hover:bg-opacity-15 items-center">
    <div class="w-8 h-8 sm:w-10 sm:h-10 bg-center bg-no-repeat rounded-full magic-card-shadow" style="background-size: cover; background-image: url('{{ avatarUrl }}');">

    </div>
    <div class="flex flex-col text-sm">
        <div class="font-bold">
            {{ displayName }}
        </div>
        <div>
            {{ username }}
        </div>
    </div>
</div>